<template>
  <b-navbar-brand to="/">
    Brands Admin
  </b-navbar-brand>
</template>

<script>
export default {}
</script>
